<template>
  <div v-if="settings_autoPlayPhotoAudio" style="margin-top: 25px;">
    <template v-if="settings && userDataPhotos && Array.isArray(userDataPhotos) && userDataPhotos.length > 0">
      <template v-if="settings_hasBackdrop">
        <b-modal
            :id="modalId"
            size="lg"
            hide-header
            hide-footer
            :visible="settings_hasBackdrop"
            @hidden="handleModalHidden"
        >
          <slide-show-standard
              :settings="settings"
              :photos="userDataPhotosFinal"
          />
        </b-modal>
        <b-button
            v-if="!modalShowing"
            @click="handleShowModal"
            size="lg"
            variant="primary"
            class="mb-2"
        >
          <b-icon
              icon="image-alt"
              aria-label="Photo"
          />
        </b-button>
      </template>
      <slide-show-standard
          v-else
          :settings="settings"
          :photos="userDataPhotosFinal"
      />
      <resource-nav-bar
          v-if="resource && !settings_hideBottomBar"
          :resource="resource"
          @open-about="handleAboutClick"
      >
        <template v-slot:buttons-right>
          <items-sidebar
              :items="userDataPhotosFinal"
              :assets-url-home="assetsURLHome"
              @item-clicked="handleItemClick"
          />
        </template>
      </resource-nav-bar>
    </template>
    <div v-else>
      <b-row>
        <b-col cols="12" class="mt-3">
          <b-skeleton-img no-aspect height="700px"/>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
import ResourceNavBar from "@/components/blockResources/_components/resourceNavBar";
import ItemsSidebar from "@/components/blockResources/_components/itemsSideBar";
import DefaultPhotos from "../../assets/json/defaultPhotoAlbum.json";
import SlideShowStandard from "./slideShowStandard";

export default {
  name: "Display_PhotoAlbum",
  mixins: [ResourceBlockDisplay],
  components: {
    SlideShowStandard,
    ResourceNavBar,
    ItemsSidebar
  },
  props: {},
  created() {},
  mounted() {
    //Pause in case of 1 second to allow audio to load,etc- I think
    this.handleAnyMemoryAdjustments();
    this.handleSlidingEnd(0);
    if(Array.isArray(this.settings_bgSongs) && this.settings_bgSongs.length > 0) {
      this.playInd = 0;
      this.playList = this.settings_bgSongs.map(audio => audio.audioURL);
      this.playRepeat();
    }
  },
  computed: {
    /* SETTINGS */
    settings_hasBackdrop() {
      return this.settings &&
      this.settings.user &&
      this.settings.user._hasBackdrop !== undefined
          ? this.settings.user._hasBackdrop
          : true;
    },
    settingsTransitionStyle() {
      return this.settings &&
      this.settings.user &&
      this.settings.user.transition
          ? this.settings.user.transition === "fade"
          : true;
    },
    settings_bgSongs() {
        return this.settings && this.settings.user && this.settings.user.bgSongs
          ? this.settings.user.bgSongs
          : [];
    },
    settings_hideBottomBar() {
      return this.settings &&
      this.settings.user &&
      this.settings.user._hideBottomBar !== undefined
          ? this.settings.user._hideBottomBar
          : true;
    },
    settings_autoPlayPhotoAudio() {
      return this.settings &&
      this.settings.user &&
      this.settings.user._autoPlayPhotoAudio !== undefined
          ? this.settings.user._autoPlayPhotoAudio
          : true;
    },
    settings_isShuffle() {
      return this.settings &&
        this.settings.user &&
        this.settings.user._isShuffle !== undefined
        ? this.settings.user._isShuffle
        : true;
    },

    /* DATA */
    userDataPhotos() {
      return this.userData && this.userData.photos
        ? this.userData.photos
        : DefaultPhotos;
    }
  },
  methods: {
    handleAnyMemoryAdjustments(){
      this.userDataPhotosFinal =  this.settings_isShuffle ?
          _.shuffle (this.userDataPhotos):
          this.userDataPhotos;
    },
    /**EACH SLIDE NEED PLAY AUDIO*/
    handlePlayAudio(audioURL) {
       this.playerCheckClear();
      this.player = new Audio(audioURL);

      if (this.player) {
        let that = this;
        this.player.addEventListener("ended", (obj)=> {
          this.playerCheckClear();
          this.pauseSlideWithInterval = false;
          this.$refs[this.slideId].next();
          // Proceed to next slide because audio has taken up
          // the interval time
        });
      }
      if (this.player) {
        this.player.play();
      }
    },
    handleItemClick(item) {
      let currentIndexOfItem = Array.isArray(this.userDataPhotosFinal)
          ? this.userDataPhotosFinal.findIndex(x => x.imgURL === item.imgURL)
          : 0;
      //@ToDo keying off the imgURL may or may not be permanent
      //@ToDo, should I require Id for all the item objectss
      this.playInd = currentIndexOfItem;
      this.handleGoToSlideAudioWith(currentIndexOfItem);
      this.handleCloseSideBar();
    },
    handleOpenSideBar() {
      this.sidebarModel = true;
    },
    handleCloseSideBar() {
      this.sidebarModel = false;
    },
    handleGoToSlideAudioWith(audioInd) {
      this.$refs[this.slideId].setSlide(audioInd);
    },
    handleShowModal() {
      debugger;
      this.$bvModal.show(this.modalId);
      //this.$root.$emit('bv::show::modal', this.modalId, '#btnShow')
      this.modalShowing = true;
    },
    handleHideModal() {
      this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow')
    },
    handleToggleModal() {
      this.$root.$emit('bv::toggle::modal', 'modal-1', '#btnToggle')
    },
    handleModalHidden(){
      this.modalShowing = false;
    }
  },
  data() {
    return {
      modalShowing: true,
      modalId: "modal-photos",
      userDataPhotosFinal:[],
      DefaultPhotos,  //show a photo with audio
      pauseSlideWithInterval: false,
      assetsURLHome: "", //assets/apps/photoalbum/',
      audioDuration: null,
      sidebarId: "photos-sidebar-1",
      sidebarModel: false,
      /* SLIDE INFO*/
      viewHeight: 250,
      slideId: "photo-slides",
      controls: false,
      indicators: false,
      slide: 0,
      sliding: null,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
